exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".align-center[data-v-428f1cdb]{margin:auto;width:100%;padding:10px}.center a[data-v-428f1cdb]{margin:0;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);

// exports
